import { render } from "./DietInformation.vue?vue&type=template&id=1c009eec"
import script from "./DietInformation.vue?vue&type=script&lang=js"
export * from "./DietInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__